import React, { FC } from 'react';
import { Button } from '@silverfort/sf-components';

interface Props {
    onClose: () => void;
}

const ShadowAdminFooter: FC<Props> = ({ onClose }) => {
    return (
        <div className="flex justify-end">
            <Button text="Done" onClick={onClose} />
        </div>
    );
};

export default ShadowAdminFooter;
